export const THEMES = {
  LEEP: 'leep',
  PWL: 'pwl',
  NAUTILUS: 'nautilus',
  STW: 'stw',
};
